import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-heatmap',
  templateUrl: './heatmap.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HeatmapComponent {}
